export const THEME_VARIANTS = {
    LIGHT: 'light',
    DARK: 'dark',
    VIP: 'vip'
} as const;

export type ThemeVariant = (typeof THEME_VARIANTS)[keyof typeof THEME_VARIANTS];

export const DEFAULT_THEME_VARIANT = THEME_VARIANTS.LIGHT;
